import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=cfc5664c&scoped=true&"
import script from "./ForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&id=cfc5664c&prod&scoped=true&lang=css&"
import style1 from "./ForgotPassword.vue?vue&type=style&index=1&id=cfc5664c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc5664c",
  null
  
)

export default component.exports